<template>
    <div class="relative">
        <slot></slot>
    </div>
</template>
